import { render, staticRenderFns } from "./bottomNavigation.vue?vue&type=template&id=1e5dee4b&scoped=true&"
import script from "./bottomNavigation.vue?vue&type=script&lang=js&"
export * from "./bottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./bottomNavigation.vue?vue&type=style&index=0&id=1e5dee4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5dee4b",
  null
  
)

export default component.exports